import React from 'react';
import { Link } from 'react-router-dom';
import { Radio, Play } from 'lucide-react';
import Newsletter from '../components/Newsletter';
import { communityMeetingImage } from '../mock';

const Watch = () => (
  <div>
    <section className="pt-[140px] pb-12 px-6 lg:px-10">
      <div className="max-w-[1100px] mx-auto fade-up">
        <span className="inline-flex items-center gap-2 px-3.5 py-1.5 rounded-full bg-[#e8743b]/12 border border-[#e8743b]/25">
          <span className="w-2 h-2 rounded-full bg-[#e8743b] pulse-dot" />
          <span className="text-[#e8743b] text-xs font-semibold tracking-wider">ON AIR</span>
        </span>
        <h1 className="font-serif-dctv text-5xl md:text-6xl font-bold text-white mt-6">Watch the channel</h1>
        <p className="text-[#bcc3cf] text-lg leading-relaxed mt-6 max-w-2xl">
          Community broadcasts streaming online - news, culture and conversation from the diaspora.
        </p>
      </div>
    </section>

    <section className="px-6 lg:px-10 pb-16">
      <div className="max-w-[1100px] mx-auto">
        <div className="relative rounded-2xl overflow-hidden border border-white/8 group">
          <img src={communityMeetingImage} alt="Diaspora African community meeting" className="w-full h-[460px] object-cover" />
          <div className="absolute inset-0" style={{ background: 'linear-gradient(180deg, rgba(10,14,22,0.2) 0%, rgba(10,14,22,0.85) 100%)' }} />
          <Link to="/watch-live" className="absolute inset-0 flex items-center justify-center">
            <span className="flex items-center justify-center w-20 h-20 rounded-full bg-gradient-to-br from-[#e8743b] to-[#f4965a] shadow-[0_8px_30px_-6px_rgba(232,116,59,0.6)] transition-transform group-hover:scale-110">
              <Play className="w-8 h-8 text-white ml-1" fill="white" />
            </span>
          </Link>
          <div className="absolute bottom-0 left-0 right-0 p-8">
            <span className="dctv-eyebrow text-[#e8743b]">Featured broadcast</span>
            <h3 className="font-serif-dctv text-2xl md:text-3xl font-bold text-white mt-2 max-w-2xl">A diaspora African community meeting</h3>
          </div>
        </div>

        <div className="mt-10 max-w-2xl">
          <p className="text-[#9aa3b2] text-[15px] leading-relaxed">
            A diaspora African community meeting - dialogue, connection and shared purpose. DCTV streams community programming online; full schedule and live channel links are announced through our newsletter and social channels.
          </p>
          <Link to="/watch-live" className="dctv-btn-primary inline-flex items-center gap-2 px-7 py-3.5 rounded-full text-[15px] font-semibold mt-7">
            <Radio className="w-4 h-4" /> Watch the live stream
          </Link>
        </div>
      </div>
    </section>

    <Newsletter />
  </div>
);

export default Watch;
